import { OpenIdConfiguration } from 'angular-auth-oidc-client';
import { environment } from '../../../environments/environment';

function createB2cOidcConfiguration(configId: string, policy: string): OpenIdConfiguration {
    return {
        configId,
        authority: `${environment.azureB2cUrl}/${policy}`,
        authWellknownEndpointUrl: `${environment.apiUrl}/v1/auth/.well-known/openid-configuration?policy=${policy}`,
        redirectUrl: window.location.origin,
        clientId: environment.azureB2cClientId,
        scope: environment.azureB2cClientId,
        responseType: 'code',
        autoUserInfo: false,
        postLogoutRedirectUri: window.location.origin,
        secureRoutes: ['http://localhost'], // TODO: add more secure routes
    };
}

function createAdOidcConfiguration(configId: string = 'azureAd'): OpenIdConfiguration {
    return {
        configId,
        authority: environment.azureAdUrl,
        authWellknownEndpointUrl: `${environment.apiUrl}/v1/admin/auth/.well-known/openid-configuration`,
        redirectUrl: `${window.location.origin}/conf`,
        clientId: environment.azureAdClientId,
        scope: 'openid',
        responseType: 'code',
        autoUserInfo: false,
        maxIdTokenIatOffsetAllowedInSeconds: 3600,
        postLogoutRedirectUri: `${window.location.origin}/conf`,
        secureRoutes: ['http://localhost/conf'], // TODO: add more secure routes
    };
}

export const AZURE_B2C_CONFIG = createB2cOidcConfiguration('azureB2c', 'B2C_1A_SIGNUP_SIGNIN');
export const AZURE_B2C_PASSWORD_RESET_CONFIG = createB2cOidcConfiguration('azureB2cPwReset', 'B2C_1A_PASSWORD_RESET');

export const AZURE_AD_CONFIG = createAdOidcConfiguration();
